import { NgModule } from '@angular/core';
import { InactivityService } from './inactivity.service';

@NgModule({
  providers: [InactivityService],
})
export class InactivityModule {}
